import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = process.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Cliente principal con anon key para todas las operaciones (respeta RLS)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Alias para compatibilidad con el código existente, pero ahora usa la anon key
export const supabaseAdmin = supabase;

// Función para autenticar con token de sesión desde URL
export async function authenticateFromUrlToken(): Promise<boolean> {
  try {
    // Obtener parámetros de la URL
    const urlParams = new URLSearchParams(window.location.search);
    let accessToken = urlParams.get('access_token');
    let refreshToken = urlParams.get('refresh_token');
    
    // Si no hay tokens en search, intentar obtenerlos del hash (#)
    if (!accessToken && window.location.hash) {
      // Eliminar el # inicial
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      accessToken = hashParams.get('access_token');
      refreshToken = hashParams.get('refresh_token');
    }
    
    if (accessToken && refreshToken) {
      console.log('🔑 Setting session from URL tokens...');
      
      const { data, error } = await supabase.auth.setSession({
        access_token: accessToken,
        refresh_token: refreshToken
      });
      
      if (error) {
        console.error('❌ Error setting session:', error);
        return false;
      }
      
      console.log('✅ Session set successfully:', data.user?.email);
      return true;
    }
    

    return false;
  } catch (error) {
    console.error('💥 Error in authenticateFromUrlToken:', error);
    return false;
  }
}


